<template>
    <div class="PlatformFinance">
        <header>
            <div class="left">
                <div class="item">
                    <p>总营收金额</p>
                    <b>￥{{PlatformFinanceData.totalRevenueAmount}}</b>
                </div>
                <div class="item">
                    <p>线上业务量</p>
                    <b>{{PlatformFinanceData.onlineBusinessVolume?PlatformFinanceData.onlineBusinessVolume:0}}</b>
                </div>
                <div class="item">
                    <p>线上营收金额</p>
                    <b>￥{{PlatformFinanceData.onlinerevenueAmount?PlatformFinanceData.onlineRevenueAmount:0}}</b>
                </div>
                <div class="item">
                    <p>线下业务量</p>
                    <b>{{PlatformFinanceData.offlineBusinessVolume?PlatformFinanceData.offlineBusinessVolume:0}}</b>
                </div>
                <div class="item">
                    <p>线下营收金额</p>
                    <b>￥{{PlatformFinanceData.offlineRevenueAmount?PlatformFinanceData.offlineRevenueAmount:0}}</b>
                </div>
            </div>
            <div class="right">
                <el-button class="minbtn" size="mini" @click="querycensus(1)">近一个月</el-button>
                <el-button class="minbtn" size="mini" @click="querycensus(3)">近三个月</el-button>
                <el-button class="minbtn" size="mini" @click="querycensus(6)">近半年</el-button>
                <el-button class="minbtn" size="mini" @click="querycensus(12)">近一年</el-button>
                <div style="margin-top: 24px;display: flex;">
                    <el-date-picker value-format="yyyy-MM-dd" style="height: 32px;" format="yyyy-MM-dd" class="datatime" v-model="censusDate" type="daterange"  range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期"></el-date-picker>
                </div>
            </div>
        </header>

        <!-- 图标 -->
        <div class="chartPage">
            <div class="item">
                <div ref="Businessrevenue" style="width: 100%;height: 480px;"></div>
            </div>
            <div class="item">
                <div ref="contractquantity" style="width: 100%;height: 480px;"></div>
            </div>
        </div>

        <div class="bottom">
            <!-- 业绩统计 -->
            <div class="Performancestatistics">
                <p class="title">销售人员业绩统计</p>
                <el-table
                :data="SalesPersonnelPerformanceStatistics"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                style="width: 100%">
                    <el-table-column label="序号" width="50px">
                        <template slot-scope="scope">
                            {{ (param.pageNum - 1) * 10 + scope.$index + 1 }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="signedBy" label="销售姓名"></el-table-column>
                    <el-table-column prop="contractAmount" label="应收费用"></el-table-column>
                    <el-table-column prop="received" label="已收费用"></el-table-column>
                    <el-table-column prop="notReceived" label="未收费用"></el-table-column>
                </el-table>

                <el-pagination
                :hide-on-single-page=true
                @current-change="handleinitialization"
                :current-page.sync="param.pageNum"
                :page-size="param.pageSize"
                layout="total, prev, pager, next"
                :total="param.PageTotal">
                </el-pagination>
            </div>

            <div class="right">
                <div class="items">
                    <p class="title"> 热门文章排行</p>
                    <div class="itemslist">
                        <div class="list" v-for="(item,index) in HotData.article">
                            <span :style="{background:index==1?'#FF6B6B':index==2?'#FF8D1A':index==3?'#43CF7C':'#BBBBBB'}">{{index}}</span>
                            <p>{{item.title}}</p>
                            <label>{{item.num}}热度</label>
                        </div>
                    </div>
                </div>
                <div class="items">
                    <p class="title"> 热门量表排行</p>
                    <div class="itemslist">
                        <div class="list" v-for="(item,index) in HotData.paper">
                            <span :style="{background:index==1?'#FF6B6B':index==2?'#FF8D1A':index==3?'#43CF7C':'#BBBBBB'}">{{index}}</span>
                            <p>{{item.title}}</p>
                            <label>{{item.num}}热度</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    data() {
        return {
            loading:false,
            censusDate:this.Global.querycensus(6),
            PlatformFinanceData:'',
            PlatformFinance:{
                startTime:'',
                endTime:''
            },
            param:{
                pageNum:1,
                pageSize:10,
                PageTotal:0
            },
            SalesPersonnelPerformanceStatistics: [],
            HotData:''
        }
    },
    watch:{
            censusDate(newval,oldeval){
                if(newval){
                    this.PlatformFinance.startTime=newval[0];
                    this.PlatformFinance.endTime=newval[1];
                }else{
                    this.PlatformFinance.startTime="";
                    this.PlatformFinance.endTime="";
                }
                this.getPlatformFinance();
            }
        },
    mounted() {
        this.PlatformFinance.startTime=this.censusDate[0]
        this.PlatformFinance.endTime=this.censusDate[1]
        this.getPlatformFinance();
        this.getSalesPersonnelPerformanceStatistics();
        this.hotFun();
    },
    methods: {
        // 获取热门文章、量表
        hotFun(){
            this.$Http_Post('/kg/contract/getTopRank').then(res=>{
                if(res.Code==0 || res.Code==200){
                    this.HotData=res.Data;
                }
            })
        },
        // 获取平台财务
        getPlatformFinance(){
            this.$Http_Post('/kg/contract/getPlatformFinance',this.PlatformFinance).then(res=>{
                if(res.Code==0){
                    this.PlatformFinanceData=res.Data;
                    if(res.Data.onlineBusinessRevenueStatistics){
                        this.Businessrevenue(res.Data.onlineBusinessRevenueStatistics);
                    }
                    if(res.Data.offlineBusinessRevenueStatistics){
                        this.offlineBusinessRevenueStatistics(res.Data.offlineBusinessRevenueStatistics)
                    }
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            })
        },
        // 获取销售人员统计
        getSalesPersonnelPerformanceStatistics(){
            this.loading=true;
            this.$Http_Post('/kg/contract/getSalesPersonnelPerformanceStatistics',this.param).then(res=>{
                this.loading=false;
                if(res.Code==0){
                    this.SalesPersonnelPerformanceStatistics=res.Data;
                    this.param.PageTotal=res.Counts
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            })   
        },
        //根据选项查询 
        querycensus(data){
            this.censusDate = this.Global.querycensus(data);
            
        },
        handleinitialization(val){
            this.param.pageNum=val;
            this.getSalesPersonnelPerformanceStatistics();
        },
        Businessrevenue(data) {
            var myChart = this.$echarts.init(this.$refs.Businessrevenue);
            var option = {
                title: {
                    text: '线上业务统计',
                    left: '20px',
                    top: '10px',
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['测评','咨询','会员'],
                    top: '10px',
                    left:'200px',
                },
                xAxis: {
                    type: 'category',
                    data:data.month
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    name:'测评',
                    data:data.evaluationOnlinerevenueAmount ,
                    type: 'line',
                    smooth: true,
                    color: '#FFB938'  
            
                },{
                    name:'咨询',
                    data:data.consultOnlinerevenueAmount,
                    type: 'line',
                    smooth: true,
                    color: '#93C22D'  

                },{
                    name:'会员',
                    data:data.memberOnlinerevenueAmount,
                    type: 'line',
                    smooth: true,
                    color: '#2A82E4'  

                }]
            };

            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },
        offlineBusinessRevenueStatistics(data) {
            let a=data.offlinerevenueAmount[0];
            var myChart = this.$echarts.init(this.$refs.contractquantity);
            var option = {
                title: {
                    text: '线下业务统计',
                    left: '20px',
                    top: '10px',
                },
                xAxis: {
                    type: 'category',
                    data:data.month
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data:data.offlinerevenueAmount,
                    type: 'line',
                    smooth: true,
                    color: '#93C22D'  
            
                }]
            };

            myChart.setOption(option);
            window.addEventListener("resize", function () {
                myChart.resize();
            });
        },
    },
}
</script>
<style>
.PlatformFinance header{display: flex;}
.PlatformFinance header .left{background: #fff;padding: 20px;flex: auto;margin-right: 10px;display: flex;border-radius: 8px;}
.PlatformFinance header .left .item{flex: 1;}
.PlatformFinance header .left .item p{font-size: 18px;color: #585858;padding-bottom: 10px;}
.PlatformFinance header .left .item b{font-size: 28px;color: #282828;}
.PlatformFinance header .right{background: #fff;padding: 20px;width: 400px;border-radius: 8px;flex: 1;}
.PlatformFinance header .el-input__inner{height: 32px;line-height: 32px;}
.PlatformFinance header .el-input__icon{line-height: 32px;display: flex;align-items: center;}
.PlatformFinance header .el-date-editor .el-range-separator{line-height: 24px;}
.PlatformFinance .chartPage{margin-top: 20px;}
.PlatformFinance .Performancestatistics{background: #fff;padding: 20px 0;margin-right: 10px;flex: 1;border-radius: 12px;}
.PlatformFinance .Performancestatistics .title{font-size: 16px;color: #333333;padding:0 20px 20px;}
.PlatformFinance .chartPage{display: flex;}
.PlatformFinance .chartPage .item{flex: 1;background: #fff;margin:0 8px;width: calc(50% - 8px);border-radius: 12px;}
.PlatformFinance .chartPage .item:first-child{margin-left: 0;}
.PlatformFinance .chartPage .item:last-child{margin-right: 0;}
.PlatformFinance .bottom{display: flex;width: 100%;margin: 20px 0 0 ;}
.PlatformFinance .bottom .right{display: flex;flex: 1;margin-left: 10px;}
.PlatformFinance .bottom .right .items{flex: 1;background: #fff;padding: 20px 18px;border-radius: 12px;margin:0 20px 0 0;}
.PlatformFinance .bottom .right .items:last-child{margin: 0;}
.PlatformFinance .bottom .right .items .title{font-size: 16px;}
.PlatformFinance .bottom .right .items .itemslist{margin-top: 10px;}
.PlatformFinance .bottom .right .items .itemslist .list{display: flex;width: 100%;padding: 10px 0;border-bottom: 1px solid #DDDDDD;align-items: center;}
.PlatformFinance .bottom .right .items .itemslist span{background: #BBBBBB;min-width: 24px;height: 24px;display: inline-block;text-align: center;line-height: 24px;color: #fff;border-radius: 4px;}
.PlatformFinance .bottom .right .items .itemslist p{font-size: 16px;padding-left: 5px;width:inherit;overflow: hidden;white-space:nowrap;text-overflow: ellipsis;}
.PlatformFinance .bottom .right .items .itemslist label{color: #FF4242;width: 85px;}
</style>